let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page026_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page026_game0/audio/false.mp3',
    // positive: 'games/page026_game0/audio/empty_true.mp3',
    click: 'games/page026_game0/audio/click.mp3',
    icon: {
      on: 'games/page026_game0/img/audioOn.png',
      off: 'games/page026_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 20,
    height: 20,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 218,
    height: 214,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 1426,
        y: 418,
      },
    },
    {
      pos: {
        x: 1389,
        y: 50,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: false,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page026_game0/audio/36_sing.mp3',

          correct: {
            image: {
              src: 'games/page026_game0/img/c2.webp',
            },
            width: 389,
            height: 310,
            correctItems: {
              images: [
                {
                  src: 'games/page026_game0/img/c2g.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 389,
                  height: 310,
                },
              ],
              text: [],
            },
          },
        },
        {
          // audioSrc: 'games/page026_game0/audio/39_dance.mp3',
          alwaysCorrect: true,

          correct: {
            image: {
              src: 'games/page026_game0/img/c1.webp',
            },
            width: 404,
            height: 282,
            incorrectItems: {
              images: [
                {
                  src: 'games/page026_game0/img/c1r.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 404,
                  height: 282,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    // {
    //   items: [
    //     {
    //       audioSrc: 'games/page026_game0/audio/37_catch.mp3',
    //       correct: {
    //         image: {
    //           src: 'games/page026_game0/img/sad.png',
    //         },
    //         width: 218,
    //         height: 214,
    //         correctItems: {
    //           images: [
    //             {
    //               src: 'games/page026_game0/img/sad_green.png',
    //               pos: {
    //                 y: 0,
    //                 x: 0,
    //               },
    //               width: 218,
    //               height: 214,
    //             },
    //           ],
    //           text: [],
    //         },
    //       },
    //     },
    //   ],
    // },
    // {
    //   items: [
    //     {
    //       audioSrc: 'games/page026_game0/audio/38_clap.mp3',
    //       correct: {
    //         image: {
    //           src: 'games/page026_game0/img/happy.png',
    //         },
    //         width: 218,
    //         height: 214,
    //         correctItems: {
    //           images: [
    //             {
    //               src: 'games/page026_game0/img/happy_green.png',
    //               pos: {
    //                 y: 0,
    //                 x: 0,
    //               },
    //               width: 218,
    //               height: 214,
    //             },
    //           ],
    //           text: [],
    //         },
    //       },
    //     },
    //   ],
    // },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page026_game0/audio/36_sing.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page026_game0/img/audioOn.png', iconOff: 'games/page026_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 590,
        x: 900,
      },
      width: '44px',
      height: '44px',
      unit: 'px',
    },
    {
      src: 'games/page026_game0/audio/38_clap.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page026_game0/img/audioOn.png', iconOff: 'games/page026_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 600,
        x: 210,
      },
      width: '44px',
      height: '44px',
      unit: 'px',
    },
    {
      src: 'games/page026_game0/audio/39_dance.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page026_game0/img/audioOn.png', iconOff: 'games/page026_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 760,
        x: 600,
      },
      width: '44px',
      height: '44px',
      unit: 'px',
    },
  ],
};

export default elements;
